import React, { useEffect, useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    Select,
    MenuItem,
    FormControl,
    Typography,
    AppBar,
    Toolbar,
    IconButton,
    TextField,
    InputLabel,
    Grid,
    Switch,
} from '@material-ui/core';
import {
    FilterList as FilterIcon,
    Edit as EditIcon,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { Pagination } from '@material-ui/lab';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getFulfilmentLocations, updateFulfilmentLocation } from '../../../store/fulfilmentLocation/fulfilmentLocationActions';

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
    },
    appBar: {
        backgroundColor: 'white',
        color: 'black',
        boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2)',
    },
    toolbar: {
        justifyContent: 'flex-end',
    },
    sopText: {
        color: '#ff6b35',
        fontWeight: 500,
        fontSize: '14px',
        cursor: 'pointer',
        textDecoration: 'underline',
        marginRight: theme.spacing(2),
    },
    createButton: {
        backgroundColor: '#3f51b5',
        color: 'white',
        marginRight: theme.spacing(2),
        '&:hover': {
            backgroundColor: '#34495e',
        },
    },
    content: {
        padding: theme.spacing(2),
    },
    controls: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    controlsLeft: {
        display: 'flex',
        alignItems: 'center',
        '& > *': {
            marginRight: theme.spacing(2),
        },
    },
    filterButton: {
        backgroundColor: '#3f51b5',
        color: 'white',
        '&:hover': {
            backgroundColor: '#34495e',
        },
    },
    tableContainer: {
        boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14)',
        borderRadius: theme.spacing(1),
    },
    sellerIdCell: {
        color: theme.palette.primary.main,
        fontWeight: 500,
    },
    headerCell: {
        backgroundColor: '#e0e0e0',
        fontWeight: 600,
    },
    statusBadge: {
        display: 'flex',
        alignItems: 'center',
        '& > *:first-child': {
            marginRight: theme.spacing(1),
        },
    },
    statusDot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: theme.palette.primary.main,
    },
    statusText: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.primary.main,
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(3),
    },
    fbsChip: {
        backgroundColor: '#fff3e0',
        color: '#f57c00',
        fontSize: '12px',
    },
    editButton: {
        color: '#3f51b5',
        '&:hover': {
            backgroundColor: 'rgba(63, 81, 181, 0.04)',
        },
    },
    editButtonText: {
        marginLeft: theme.spacing(0.5),
        fontSize: '13px',
        fontWeight: 500,
    },
    nonFbsChip: {
        backgroundColor: '#f0f0f0',
        color: '#333',
        fontSize: '12px',
    },
    formControl: {
        minWidth: 120,
    },
    filterField: {
        marginBottom: theme.spacing(2),
        width: '100%',
    },
    clearButton: {
        marginRight: theme.spacing(1),
        color: '#666',
        borderColor: '#666',
    },
    applyButton: {
        backgroundColor: '#3f51b5',
        color: 'white',
        '&:hover': {
            backgroundColor: '#34495e',
        },
    },
    activeFilterBadge: {
        backgroundColor: '#f44336',
        color: 'white',
        borderRadius: '50%',
        width: 20,
        height: 20,
        fontSize: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: theme.spacing(0.5),
    },
    statusSwitch: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },
    statusLabel: {
        fontSize: '12px',
        color: '#666',
        marginTop: theme.spacing(0.5),
    },
}));

export default function FulfilmentLocation() {
    const classes = useStyles();
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filterOpen, setFilterOpen] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [updatingStatus, setUpdatingStatus] = useState(null);
    
    const [filters, setFilters] = useState({
        warehouse_id: '',
        warehouse_name: '',
        warehouse_type: '',
    });

    const history = useHistory();
    const { fulfilmentLocations } = useSelector(state => state.fulfilmentLocation);
    const dispatch = useDispatch();

    const handleCreateSellerLocation = () => {
        history.push("/location/CreateFulfilmentLocation");
    };

    const handleEditFulfilment = (fulfilment) => {
        history.push({
            pathname: "/location/CreateFulfilmentLocation",
            state: { 
                editMode: true, 
                fulfilmentData: fulfilment 
            }
        });
    };

    // Handle status toggle
    const handleStatusToggle = (fulfilment, newStatus) => {
    setUpdatingStatus(fulfilment._id);
    
    // Only send the status field
    const updateData = {
        status: newStatus
    };

    dispatch(updateFulfilmentLocation(
        fulfilment._id, 
        updateData,
        () => {
            setUpdatingStatus(null);
            dispatch(getFulfilmentLocations());
        }
    ));
};

    // Filter functions
    const handleFilterOpen = () => {
        setFilterOpen(true);
    };

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const applyFilters = () => {
        let filtered = fulfilmentLocations;

        if (filters.warehouse_id) {
            filtered = filtered.filter(item => 
                item.warehouse_id.toLowerCase().includes(filters.warehouse_id.toLowerCase())
            );
        }

        if (filters.warehouse_name) {
            filtered = filtered.filter(item => 
                item.warehouse_name.toLowerCase().includes(filters.warehouse_name.toLowerCase())
            );
        }

        if (filters.warehouse_type) {
            filtered = filtered.filter(item => 
                item.warehouse_type.toLowerCase().includes(filters.warehouse_type.toLowerCase())
            );
        }

        setFilteredData(filtered);
        setCurrentPage(1);
        setFilterOpen(false);
    };

    const clearFilters = () => {
        setFilters({
            warehouse_id: '',
            warehouse_name: '',
            warehouse_type: '',
        });
        setFilteredData(fulfilmentLocations);
        setCurrentPage(1);
        setFilterOpen(false);
    };

    // Check if any filter is active
    const hasActiveFilters = Object.values(filters).some(value => value !== '');
    const activeFilterCount = Object.values(filters).filter(value => value !== '').length;

    // Get unique values for dropdown options
    const getUniqueValues = (field) => {
        return [...new Set(fulfilmentLocations.map(item => item[field]).filter(Boolean))];
    };

    // Pagination logic
    const totalItems = filteredData.length;
    const totalPages = Math.ceil(totalItems / rowsPerPage);
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedData = filteredData.slice(startIndex, endIndex);

    useEffect(() => {
        dispatch(getFulfilmentLocations());
    }, [dispatch]);

    useEffect(() => {
        setFilteredData(fulfilmentLocations);
    }, [fulfilmentLocations]);

    return (
        <div className={classes.root}>
            <AppBar position="static" className={classes.appBar}>
                <Toolbar className={classes.toolbar}>
                    <Typography className={classes.sopText}>
                        SOP
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={handleCreateSellerLocation}
                        className={classes.createButton}
                    >
                        Create Fulfilment Location
                    </Button>
                </Toolbar>
            </AppBar>

            <Container maxWidth={false} className={classes.content}>
                <Box className={classes.controls}>
                    <Box className={classes.controlsLeft}>
                        <Button
                            variant="contained"
                            startIcon={<FilterIcon />}
                            className={classes.filterButton}
                            onClick={handleFilterOpen}
                        >
                            Filter
                            {hasActiveFilters && (
                                <span className={classes.activeFilterBadge}>
                                    {activeFilterCount}
                                </span>
                            )}
                        </Button>
                        <Typography variant="body2" color="textSecondary">
                            {startIndex + 1} - {Math.min(endIndex, totalItems)} of {totalItems}
                        </Typography>
                        <FormControl className={classes.formControl}>
                            <Select
                                value={rowsPerPage}
                                onChange={(e) => setRowsPerPage(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value={10}>10 Per Page</MenuItem>
                                <MenuItem value={25}>25 Per Page</MenuItem>
                                <MenuItem value={50}>50 Per Page</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    
                </Box>
                {filterOpen &&(
                    <Box>
                        <Grid container spacing={2}>
                         <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="Warehouse Id"
                                value={filters.warehouse_id}
                                onChange={(e) => handleFilterChange('warehouse_id', e.target.value)}
                                className={classes.filterField}
                                variant="outlined"
                                size="small"
                                placeholder="Search by warehouse Id..."
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <TextField
                                label="Warehouse Name"
                                value={filters.warehouse_name}
                                onChange={(e) => handleFilterChange('warehouse_name', e.target.value)}
                                className={classes.filterField}
                                variant="outlined"
                                size="small"
                                placeholder="Search by warehouse name..."
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                            <FormControl className={classes.filterField} variant="outlined" size="small">
                                <InputLabel>Warehouse Type</InputLabel>
                                <Select
                                    value={filters.warehouse_type}
                                    onChange={(e) => handleFilterChange('warehouse_type', e.target.value)}
                                    label="Warehouse Type"
                                >
                                    <MenuItem value="">All Types</MenuItem>
                                    {getUniqueValues('warehouse_type').map((type) => (
                                        <MenuItem key={type} value={type}>
                                            {type}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} lg={3}>
                        <Button 
                        onClick={clearFilters} 
                        variant="outlined"
                        className={classes.clearButton}
                    >
                        Clear All
                    </Button>
                    <Button 
                        onClick={applyFilters} 
                        variant="contained"
                        className={classes.applyButton}
                    >
                        Apply Filters
                    </Button>
                    </Grid>
                    </Grid>
                    </Box>
                    )}

                <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.headerCell}>Warehouse ID</TableCell>
                                <TableCell className={classes.headerCell}>Warehouse Type</TableCell>
                                <TableCell className={classes.headerCell}>Warehouse Name</TableCell>
                                <TableCell className={classes.headerCell}>Country</TableCell>
                                <TableCell className={classes.headerCell}>State</TableCell>
                                <TableCell className={classes.headerCell}>Area</TableCell>
                                <TableCell className={classes.headerCell}>Status</TableCell>
                                <TableCell className={classes.headerCell}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedData.map((fulfilment, index) => (
                                <TableRow
                                    key={fulfilment._id}
                                    hover
                                    style={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#f9f9f9',
                                    }}
                                >
                                    <TableCell className={classes.fulfilmentIdCell}>
                                        {fulfilment.warehouse_id}
                                    </TableCell>
                                    <TableCell>{fulfilment.warehouse_type}</TableCell>
                                    <TableCell>{fulfilment.warehouse_name}</TableCell>
                                    <TableCell>{fulfilment.country}</TableCell>
                                    <TableCell>{fulfilment.state}</TableCell>
                                    <TableCell>{fulfilment.area}</TableCell>
                                    <TableCell>
                                        <div className={classes.statusSwitch}>
                                            <Switch
                                                checked={fulfilment.status === true || fulfilment.status === 'active'}
                                                onChange={(e) => handleStatusToggle(fulfilment, e.target.checked)}
                                                color="primary"
                                                disabled={updatingStatus === fulfilment._id}
                                                size="small"
                                            />
                                            <Typography className={classes.statusLabel}>
                                                {updatingStatus === fulfilment._id 
                                                    ? 'Updating...' 
                                                    : (fulfilment.status === true || fulfilment.status === 'active') 
                                                        ? 'Active' 
                                                        : 'Inactive'
                                                }
                                            </Typography>
                                        </div>
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            className={classes.editButton}
                                            size="small"
                                            onClick={() => handleEditFulfilment(fulfilment)}
                                        >
                                            <EditIcon /> <span className={classes.editButtonText}>Edit</span>
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Box className={classes.pagination}>
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        color="primary"
                        showFirstButton
                        showLastButton
                    />
                </Box>
            </Container>
        </div>
    );
}